import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import './trip-check-out-modal.scss';
import { SVGS } from '../../assets';
import { CommonButton } from '../../components';
import { getCurrentCustomer, useAppSelector } from '@zonofi/zono-money-store';
import { TripCheckInOutType } from '../../types';
import moment from 'moment';

interface TripCheckOutModalProps {
  open: boolean;
  onClose: () => void;
  type: TripCheckInOutType;
  onCheckOutPress?: () => void;
}

export const TripCheckOutModal: React.FC<TripCheckOutModalProps> = ({
  open,
  onClose,
  type,
  onCheckOutPress,
}) => {
  const currentCustomer = useAppSelector(getCurrentCustomer);

  const checkInOutConfig = {
    [TripCheckInOutType.CHECK_OUT]: {
      image: SVGS.ConfirmCheckOut,
      heading: 'Check Out',
      subHeading: 'Are you sure you want to check-out?',
      primaryText: 'Yes, Check Out',
      onPrimaryPress: onCheckOutPress,
    },
    [TripCheckInOutType.CHECK_IN_SUCCESS]: {
      image: SVGS.CheckInOutSuccess,
      heading: `Check-in to ${currentCustomer?.customerName}\nis Successful`,
      subHeading: moment().format('dddd, DD MMM YYYY, hh:mm A'),
      primaryText: 'Done',
      onPrimaryPress: onClose,
    },
    [TripCheckInOutType.CHECK_OUT_SUCCESS]: {
      image: SVGS.CheckInOutSuccess,
      heading: `Check-out from ${currentCustomer?.customerName}\nis Successful`,
      subHeading: moment().format('dddd, DD MMM YYYY, hh:mm A'),
      primaryText: 'Done',
      onPrimaryPress: onClose,
    },
  };

  const config = checkInOutConfig?.[type];

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{ className: 'checkout-modal__drawer' }}
    >
      <Box className="checkout-modal__container">
        <>
          <div className="check-out__pending">
            <img src={config?.image} width={135} height={135} />

            <div className="check-out__required-message">
              <span className="check-out__required-message__heading font-semibold">
                {config?.heading}
              </span>
              {/* <br /> */}
              <span className="check-out__required-message__sub-heading font-regular">
                {config?.subHeading}
              </span>
            </div>
          </div>

          <CommonButton
            text={config?.primaryText}
            onPress={() => config?.onPrimaryPress?.()}
            spinnerColor="white"
          />
        </>
      </Box>
    </SwipeableDrawer>
  );
};
